export default __webpack_public_path__ + "10646c387dacb62a3aa9e39cdf1d4ee8.ogg";